import Tooltip from '@material-ui/core/Tooltip';
import { camelCase } from 'lodash';
import React, { SyntheticEvent } from 'react';
import { white50 } from '../../Styles/Colours';
import { CloseIcon } from '../Icons';
import { StyledDialogActions } from './StyledDialogActions';
import { StyledDialogAppBar } from './StyledDialogAppBar';
import { StyledDialogContent } from './StyledDialogContent';
import { StyledDialogCore } from './StyledDialogCore';
import { Button } from '../Button';

export class StyledDialog extends React.Component<{
    actions?: React.ReactNode;
    open: boolean;
    size: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | false;
    modal?: boolean;
    fullHeight?: boolean;
    titleBarLeft?: React.ReactNode;
    title?: string;
    contentHeight?: number;
    titleBarRight?: React.ReactNode;
    headerExtraContents?: React.ReactNode;
    alertContent?: React.ReactNode;
    titleComponent?: React.ReactNode;
    actionsComponent?: React.ReactNode;
    contentComponent?: React.ReactNode;
    preventSideBarCollapse?: boolean;
    testId?: string;
    isSubmitting?: boolean;
    backgroundClass?: string;
    onExited?(): void;
    onRequestClose?(event: SyntheticEvent<{}>): void;
    sidebarRender?(props: { collapsed: boolean }): React.ReactNode;
    closeFunction?(): void;
}> {
    public static muiName = 'Dialog';

    public render() {
        const {
            title,
            titleBarRight,
            titleBarLeft,
            headerExtraContents,
            contentHeight,
            children,
            actions,
            sidebarRender,
            alertContent,
            titleComponent,
            actionsComponent,
            contentComponent,
            closeFunction,
            isSubmitting,
            ...otherProps
        } = this.props;

        const finalTitleComponent = !!this.props.closeFunction ? (
            <StyledDialogAppBar
                title={title}
                titleBarRight={
                    <Tooltip title='Close'>
                        <Button
                            iconOnly
                            onClick={this.props.closeFunction}
                            disabled={isSubmitting}
                            testId={`dialog-control-close`}
                        >
                            <CloseIcon color={white50} />
                        </Button>
                    </Tooltip>
                }
                titleBarLeft={titleBarLeft}
                headerExtraContents={headerExtraContents}
            />
        ) : (
            titleComponent || (
                <StyledDialogAppBar
                    title={title}
                    titleBarRight={titleBarRight}
                    titleBarLeft={titleBarLeft}
                    headerExtraContents={headerExtraContents}
                />
            )
        );

        const finalContentComponent = contentComponent || (
            <StyledDialogContent contentHeight={contentHeight} backgroundClass={this.props.backgroundClass}>
                {children}
            </StyledDialogContent>
        );

        const finalActionsComponent = actionsComponent || <StyledDialogActions>{actions}</StyledDialogActions>;

        const testId = this.props.testId || camelCase(this.props.title);

        return (
            <StyledDialogCore
                {...otherProps}
                testId={testId}
                sidebarRender={sidebarRender}
                titleComponent={finalTitleComponent}
                contentComponent={finalContentComponent}
                actionsComponent={finalActionsComponent}
                alertContent={alertContent}
            />
        );
    }
}
